import type { DiscoveryRun } from '@app/types/sdk';

export interface DiscoveryRunSelectionState {
  selectedSiteJobId: string | null;
  selectedRunId: string | null;
  pendingRun: DiscoveryRun | null;
  runDetailOpen: boolean;
}

export const selectDiscoveryJobState = (
  state: DiscoveryRunSelectionState,
  jobId: string | null,
  resetRun = true
): DiscoveryRunSelectionState => ({
  selectedSiteJobId: jobId,
  selectedRunId: resetRun ? null : state.selectedRunId,
  pendingRun: resetRun ? null : state.pendingRun,
  runDetailOpen: resetRun ? false : state.runDetailOpen
});

export const selectDiscoveryRunsForJob = (
  selectedJobId: string | null | undefined,
  runs: DiscoveryRun[],
  pendingRun: DiscoveryRun | null
): DiscoveryRun[] => {
  if (!selectedJobId) {
    return [];
  }
  if (!pendingRun?.id || pendingRun.jobId !== selectedJobId) {
    return runs;
  }
  return runs.some((item) => item.id === pendingRun.id) ? runs : [pendingRun, ...runs];
};
